// Centralized date formatting — dates are always shown as mm/dd/yyyy.
const pad = (n) => String(n).padStart(2, "0");

// Accepts a Date, an ISO datetime string, or a "YYYY-MM-DD" date-only string
// (date-only is parsed as local midnight to avoid timezone shifting the day).
function toDate(v) {
  if (v instanceof Date) return v;
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return new Date(v + "T00:00:00");
  return new Date(v);
}

export function fmtDate(v) {
  try {
    const d = toDate(v);
    if (isNaN(d.getTime())) return typeof v === "string" ? v : "";
    return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
  } catch {
    return typeof v === "string" ? v : "";
  }
}

export function fmtTime(v) {
  try {
    const d = toDate(v);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  } catch {
    return "";
  }
}

export function fmtDateTime(v) {
  try {
    const d = toDate(v);
    if (isNaN(d.getTime())) return typeof v === "string" ? v : "";
    return `${fmtDate(d)}, ${fmtTime(d)}`;
  } catch {
    return typeof v === "string" ? v : "";
  }
}
